<div class="campaign-landing" *ngIf="campaign">
  <!-- Hero Section -->
  <section class="hero" [style.background]="campaign.themeGradient" [style.border-bottom-color]="campaign.themeColor">
    <div class="hero-content">
      <div class="tag" [style.color]="campaign.themeColor">{{ campaign.bannerBadgeText }}</div>
      <h1>{{ campaign.title }}</h1>
      <p>{{ campaign.description }}</p>
    </div>
  </section>

  <!-- Content Section -->
  <section class="content-section">
    <div class="section-header">
      <h2>Campaign Resources</h2>
      <p>Discover articles, tips, and videos related to this campaign.</p>
    </div>

    <div class="grid-container">
      <div class="card" *ngFor="let item of campaign.resources">
        <div class="card-image" [style.background-image]="'url(' + item.imageUrl + ')'">
           <span class="category-badge" [style.background]="campaign.themeColor">{{ item.category }}</span>
        </div>
        <div class="card-content">
          <h3>{{ item.title }}</h3>
          <p>{{ item.summary }}</p>
          <a href="javascript:void(0)" class="read-more" (click)="onResourceClick(item)">Read More &rarr;</a>
        </div>
      </div>
      
      <div *ngIf="!campaign.resources || campaign.resources.length === 0" class="no-resources">
        <p>No resources available for this campaign yet.</p>
      </div>
    </div>
  </section>
</div>

<div class="campaign-landing error-state" *ngIf="!campaign">
  <h2>Campaign not found</h2>
  <p>The campaign you are looking for does not exist or is no longer active.</p>
</div>
